import { render } from "./EditAttachment.vue?vue&type=template&id=12828fa9&scoped=true"
import script from "./EditAttachment.vue?vue&type=script&lang=js"
export * from "./EditAttachment.vue?vue&type=script&lang=js"

import "./EditAttachment.vue?vue&type=style&index=0&id=12828fa9&lang=scss&scoped=true"
import "./EditAttachment.vue?vue&type=style&index=1&id=12828fa9&lang=scss"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12828fa9"]])

export default __exports__